module.exports = __webpack_public_path__ + "img/logo_so_black.e90fae16.png";